<script>
import Axios from 'axios';
import { mapGetters } from 'vuex';
import BlockPagination from '../utility/block-pagination';
import ModalNote from './modal-note.vue';
import Multiselect from 'vue-multiselect';
import ModalConfirmRemove from './modal-confirm-remove.vue';

export default {
  name: 'card-notes',
  props: ['notes', 'card_id'],

  data() {
    return {
      note: '',
      note_id: null,
      note_type: '',
      filter: '',
      fields: [
        {
          label: 'Note Details',
          key: 'note',
          sortable: true,
          tdClass: 'card-note',
        },
        {
          label: 'Type',
          key: 'type',
          sortable: true,
          tdClass: 'type-note',
        },
        {
          label: 'Created By',
          key: 'createdBy',
          sortable: true,
          tdClass: 'created-by',
        },
        {
          label: 'Date',
          key: 'createdOn',
          sortable: true,
          tdClass: 'created-on',
        },
        {
          label: 'Action',
          key: 'action',
          tdClass: 'action',
        },
      ],
      notesPerPage: 9,
      notesCurrentPage: 1,
      optionsTypes: [
        { id: 'General', name: 'General' },
        { id: 'AccidentDetails', name: 'Accident Details' },
        { id: 'Authority', name: 'Authority' },
        { id: 'Customer', name: 'Customer' },
        { id: 'EstimateNote', name: 'Estimate Note (Added)' },
        { id: 'SubletInvoice', name: 'Sublet Invoice' },
        { id: 'SupplierInvoice', name: 'Supplier Invoice' },
        { id: 'SupplierCredit', name: 'Supplier Credit' },
        { id: 'Mechanical', name: 'Mechanical' },
        { id: 'VehicleIdentification', name: 'Vehicle Identification' }
      ],
    };
  },

  methods: {
    loadNotes(notes) {
      this.$emit('loadNotes',notes);
    },
    selectedOptionsType(item) {
      (this.note_id = item.id), this.saveNote(item);
    },
    clickRemoveBtn(note) {
        this.note_id = note.id
    },
    addNote() {
      if (!this.isStatusActive) {
        return;
      }
      this.note_id = null;
      this.note = '';
      this.note_type = 'General'
    },
    editNote(note) {
      if (!this.isStatusActive) {
        return;
      }
      this.note_id = note.id;
      this.note = note.note;
      this.note_type = note.type;
      this.note = this.note.replace(/<br \/>/g, '');
    },
    removeNote: function (noteId) {
    const note = this.notes.find((n) => n.id === noteId);
      if (!this.isStatusActive) {
        return;
      }
      NProgress.start();
      if (note.id == null) {
        return;
      }
      let url = `/fe/note/${note.id}`;
      Axios({
        method: 'DELETE',
        responseType: 'json',
        url: url,
        validateStatus: function (status) {
          return status < 500;
        },
        data: {},
      })
        .then((response) => {
          if (response.status == 200) {
            toastr.success(response.data._msg);
            this.loadNotes(response.data.notes);
          } else {
            toastr.error(response.data._msg);
          }
          NProgress.done();
        })
        .catch((error) => {
          NProgress.done();
          toastr.error(error);
        });
    },
    saveNote(note) {
      if (!this.isStatusActive) {
        return;
      }
      NProgress.start();
      let card_id = this.card_id;
      let url = '';

      if (note.id == null) {
        url = '/fe/note';
      } else {
        url = `/fe/note/${note.id}`;
      }
      Axios({
        method: 'post',
        responseType: 'json',
        url: url,
        validateStatus: function (status) {
          return status < 500;
        },
        data:{
          note: note.note.replace(/<br \/>/g, ""),
          card_id: card_id,
          type: note.type,
        },
      })
        .then((response) => {
          if (response.status == 200) {
            toastr.success(response.data._msg);
            // if (this.note_id == null) {
            //   this.note_id = response.data.note_id;
            // }
            this.loadNotes(response.data.notes);
          } else {
            toastr.error(response.data.msg);
          }
          NProgress.done();
        })
        .catch((error) => {
          NProgress.done();
          toastr.error(error);
        });
    },
    onEstimateNote(item) {
      const est = 'EstimateNote';
      this.$set(item, 'type', est);
      this.saveNote(item);
    },
  },
  computed: {
    ...mapGetters({
      isStatusActive: 'isStatusActive',
    }),
    totalNotes: function () {
      return this.notes.length;
    },
    fromNotes: function () {
      if (this.totalNotes == 0) {
        return 0;
      }
      const fromNotes = (this.notesCurrentPage - 1) * this.notesPerPage + 1;
      return fromNotes;
    },
    toNotes: function () {
      const toNotes =
        (this.notesCurrentPage - 1) * this.notesPerPage + this.notesPerPage;
      if (toNotes > this.totalNotes) return this.totalNotes;
      return toNotes;
    },
  },
  components: {
    BlockPagination,
    'modal-note': ModalNote,
    Multiselect,
    ModalConfirmRemove,
  },
};
</script>

<template>
  <div class="additional-block-cards-notes">
    <div class="notes-table nav-title" style="margin-bottom: 65px; padding-top:0; padding-bottom:0">
        <b-table

          id="card-notes-table"
          hover
          :items="notes"
          :fields="fields"
          :current-page="notesCurrentPage"
          :per-page="notesPerPage"
        >
          <template v-slot:cell(note)="data">
            <div v-html="data.item.note"></div>
          </template>
          <template v-slot:cell(type)="data">
            <multiselect
              :value="optionsTypes.find((o) => o.id === data.item.type) || null"
              @input="(option) => (data.item.type = option ? option.id : null)"
              :options="optionsTypes"
              :option-height="29"
              :max-height="270"
              :close-on-select="true"
              :allow-empty="false"
              :show-labels="false"
              :tabindex="2"
              :multiple="false"
              :select-label="''"
              :deselect-label="''"
              @select="selectedOptionsType(data.item)"
              track-by="id"
              label="name"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </div>
              </template>
            </multiselect>
          </template>
          <template v-slot:cell(createdBy)="data">
            <div>{{ data.item.createdBy }}</div>
          </template>
          <template v-slot:cell(createdOn)="data">
            <div>{{ data.item.createdOn|formatDateTime }}</div>
          </template>
          <template v-slot:cell(action)="data">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: inline-block">
                <a
                  href=""
                  @click.prevent="editNote(data.item)"
                  data-toggle="modal"
                  :data-target="isStatusActive ? '#noteBoxModal' : ''"
                  ><i class="bx bx-pencil"></i
                ></a>
              </div>
              <div style="display: inline-block">
                <span
                  v-if="data.item.type !== 'EstimateNote'"
                  @click.prevent="onEstimateNote(data.item)"
                  v-b-tooltip.hover="{
                    customClass: 'ps-tooltip',
                    title: 'Add this note to the Estimate',
                    placement: 'left',
                  }"
                  class="cursor-ptr"
                >
                  <i
                    class="bx bxs-file-plus"
                    style="color: #000000; font-size: x-large"
                  ></i
                ></span>
              </div>
              <div style="display: inline-block">
                <a
                  href=""
                  data-toggle="modal"
                  :data-target="'#confirmRemoveModal'"
                  @click.prevent="clickRemoveBtn(data.item)"
                  style="width: 19px; height: 19px; margin: 0"
                  class="nav-link btn_trush"
                ></a>
              </div>
            </div>
          </template>
        </b-table>
    </div>
    <block-pagination
      :role="'Notes'"
      :count="notes.length"
      :countFiltered="notes.length"
      :currentPage="notesCurrentPage"
      @changedCurrentPage="(value) => (notesCurrentPage = value)"
      :perPage="notesPerPage"
      @changedPerPage="(value) => (notesPerPage = value)"
    >
    </block-pagination>
    <modal-note
      ref="noteModal"
      modal-id="noteBoxModal"
      :note-id="note_id"
      :note="note"
      :type="note_type"
      @save="saveNote"
    ></modal-note>
    <modal-confirm-remove modal-id="confirmRemoveModal" @confirm="removeNote(note_id)"/>

  </div>
</template>

<style>
.V3 .new-note-btn {
  position: fixed;
  top: 146px;
  right: 0;
  z-index: 1000;
  font-family: 'Nunito Sans';
  font-size: 13px;
  font-weight: bold;
}

.nav-title {
  padding: 15px 15px 0 15px;
}

.notes-table .note-action a {
  color: #1b1e38;
}

.notes-table .note-action > a {
  font-size: 19px;
}

.notes-table .card-note {
  min-width: 200px;
  overflow-wrap: break-word;
  font-size: 12px;
  font-weight: 600;
}
.notes-table .type-note {
  width: 205px;
  overflow-wrap: break-word;
  font-size: 12px;
  font-weight: 600;
}
.notes-table .created-by {
  max-width: 60px;
  min-width: 40px;
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
}

.notes-table .created-on {
  max-width: 80px;
  font-size: 12px;
  font-weight: 600;
}

.notes-table .action {
  min-width: 95px;
  max-width: 120px;
  width: 120px;
}

.notes-table .bx-pencil {
  font-size: 19px;
  color: black;
}

.notes-table tr td {
  padding: 16px 15px 14.5px 15px !important;
}

/* .V3 .notes-table #card-notes-table tbody:before,
    .V3 .notes-table #card-notes-table tbody:after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 100%;
        background-color: #ffffff;
        position: absolute;
        left: 0;
        top: 120px;
    }

    .V3 .notes-table #card-notes-table tbody:after {
        left: unset;
        right: 0;
    } */
</style>
